var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobilePhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 46,
  x: 15,
  y: 5,
  strokeWidth: 2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M25 47h6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 5h14v1a2 2 0 0 1-2 2H23a2 2 0 0 1-2-2z"
}))));
export default SvgMobilePhone;